<div class="modal-header">
    <h4 class="modal-title">Smart Insurance Eligibility</h4>
</div>
<div class="modal-body">
    Please confirm you want to run the Smart Insurance Eligibility check
</div>
<div class="modal-footer">
    <button type="button"
            (click)="modalDismiss($event, 'cancel')"
            class="btn btn-outline-secondary">
        Cancel
    </button>
    <button type="button"
            (click)="runSmartEligibilityCheck($event, 'userNeedsToConfirm')"
            class="btn btn-outline-primary">
        Run & Review Changes
    </button>
    <button type="button"
            (click)="runSmartEligibilityCheck($event, 'proceed')"
            class="btn btn-primary mr-2">
        Run
    </button>
</div>
